import { listen, qs, add, remove } from "@fluorescent/dom";
import { on } from "@/glow/events";

const sel = {
  container: ".social-share",
  button: ".social-share__button",
  input: ".social-share__input",
  popup: ".social-sharing__popup",
  copyURLButton: ".social-share__copy-url",
  successMessage: ".social-share__success-message",
};

const classes = {
  hidden: "hidden",
  linkCopied: "social-sharing__popup--success",
};

export default node => {
  if (!node) return;

  const button = qs(sel.button, node);
  const popup = qs(sel.popup, node);
  const input = qs(sel.input, node);
  const copyURLButton = qs(sel.copyURLButton, node);
  const successMessage = qs(sel.successMessage, node);
  const { enableOsShare } = button.dataset;
  let clickListener;

  // Use native OS share if available
  if (navigator.canShare && enableOsShare === "true") {
    const shareData = {
      title: button.dataset.title,
      text: button.dataset.text,
      url: button.dataset.url,
    };

    clickListener = listen(button, "click", () => {
      navigator.share(shareData);
    });
  } else {
    clickListener = listen(window, "click", handleClick);
  }

  // Close the popup if the header account link is clicked
  on("header-account-link:clicked", close);

  // Hide copy button on old browsers
  if (!navigator.clipboard || !navigator.clipboard.writeText) {
    add(copyURLButton, classes.hidden);
  }

  function handleClick(evt) {
    const buttonClicked = evt.target.closest(sel.button) === button;
    const popupClicked = evt.target.closest(sel.popup) === popup;
    const inputClicked = evt.target.closest(sel.input) === input;
    const copyURLClicked =
      evt.target.closest(sel.copyURLButton) === copyURLButton;

    let isActive = false;

    if (buttonClicked) {
      isActive = button.getAttribute("aria-expanded") === "true";
    }

    // click happened outside of this popup
    if (!popupClicked) {
      close();
    }

    // click happened in this social button and the button is not active
    if (buttonClicked && !isActive) {
      open();
    }

    if (inputClicked) {
      input.select();
    }

    if (copyURLClicked) {
      const { url } = copyURLButton.dataset;
      writeToClipboard(url).then(showSuccessMessage, showErrorMessage);
    }
  }

  function close() {
    button.setAttribute("aria-expanded", false);
    popup.setAttribute("aria-hidden", true);
  }

  function open() {
    button.setAttribute("aria-expanded", true);
    popup.setAttribute("aria-hidden", false);
  }

  function writeToClipboard(str) {
    return navigator.clipboard.writeText(str);
  }

  function showMessage(message) {
    successMessage.innerHTML = message;
    remove(successMessage, classes.hidden);
    add(popup, classes.linkCopied);
    setTimeout(() => {
      add(successMessage, classes.hidden);
      remove(popup, classes.linkCopied);
    }, 2000);
  }

  function showSuccessMessage() {
    const { successMessage } = copyURLButton.dataset;
    showMessage(successMessage);
  }

  function showErrorMessage() {
    if (window.Shopify?.designMode) return;

    const { errorMessage } = copyURLButton.dataset;
    showMessage(errorMessage || "Error copying link.");
  }

  function unload() {
    close();
    clickListener();
  }

  return { unload };
};
